export default {
  getGroups($state) {
    return $state.groups;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};
